import { Icon, IconProps } from "@chakra-ui/react";

export function RouteIcon(props: IconProps) {
  return (
    <Icon viewBox="0 0 33 9" fill="currentColor" {...props}>
      <path d="M0 4.5C0 6.70914 1.79086 8.5 4 8.5C6.20914 8.5 8 6.70914 8 4.5C8 2.29086 6.20914 0.5 4 0.5C1.79086 0.5 0 2.29086 0 4.5ZM25 4.5C25 6.70914 26.7909 8.5 29 8.5C31.2091 8.5 33 6.70914 33 4.5C33 2.29086 31.2091 0.5 29 0.5C26.7909 0.5 25 2.29086 25 4.5ZM4 5.25H5.5625V3.75H4V5.25ZM8.6875 5.25H11.8125V3.75H8.6875V5.25ZM14.9375 5.25H18.0625V3.75H14.9375V5.25ZM21.1875 5.25H24.3125V3.75H21.1875V5.25ZM27.4375 5.25H29V3.75H27.4375V5.25Z" />
    </Icon>
  );
}
